import PropTypes from 'prop-types'
import React from 'react'

import './styles.css'

// "The rest of the course, visibly locked" (SPEC-052 FR-10). Locked tiles are
// deliberately not clickable — they exist to create the pull toward the trial
// block that follows them, not to navigate anywhere.
function LockedLessons({ title = '', lessons }) {
  if (!lessons.length) return null
  return (
    <section className="lm-locked">
      <div className="lm-locked__inner wrapper">
        {title && <h2 className="lm-locked__heading">{title}</h2>}
        <ul className="lm-locked__grid">
        {lessons.map((lesson) => (
          <li
            key={lesson.id}
            className="lm-locked__tile"
            aria-label={`Locked lesson: ${lesson.title}`}
          >
            <div
              className="lm-locked__thumb"
              style={
                lesson.thumbnail?.default
                  ? { backgroundImage: `url(${lesson.thumbnail.default})` }
                  : undefined
              }
            >
              <span className="lm-locked__padlock" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="18" height="18">
                  <path
                    fill="currentColor"
                    d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5Zm-3 8V7a3 3 0 1 1 6 0v3H9Z"
                  />
                </svg>
              </span>
            </div>
            {lesson.order != null && (
              <span className="lm-locked__eyebrow">Lesson {lesson.order}</span>
            )}
            <span className="lm-locked__title">{lesson.title}</span>
            {lesson.artist?.title && (
              <span className="lm-locked__artist">{lesson.artist.title}</span>
            )}
          </li>
        ))}
        </ul>
      </div>
    </section>
  )
}

LockedLessons.propTypes = {
  title: PropTypes.string,
  lessons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      order: PropTypes.number,
      title: PropTypes.string.isRequired,
      artist: PropTypes.shape({ title: PropTypes.string }),
      thumbnail: PropTypes.shape({ default: PropTypes.string })
    })
  ).isRequired
}

export default LockedLessons
